import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from '@material-ui/core';
import React, { useEffect, useRef } from 'react';
import useStyles from './styles';

type Props = {
  open: boolean;
  closeHandler: () => void;
  title: string;
  message: string;
  buttonText?: string;
  className?: string;
};

const SimpleConfirmationDialog = ({
  open,
  closeHandler,
  title,
  message,
  buttonText = 'OK',
  className = '',
}: Props) => {
  const classes = useStyles();
  const buttonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (open && buttonRef.current) {
      const event = new window.KeyboardEvent('keydown', { key: 'Tab' });
      const target = buttonRef.current;

      if (target !== null) {
        target.dispatchEvent(event);
      }
    }
  }, [open, buttonRef]);

  useEffect(() => {
    if (open && buttonRef.current) {
      buttonRef.current.focus();
    }
  }, [open, buttonRef]);

  return (
    <Dialog
      open={open}
      onClose={closeHandler}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      disablePortal
      disableBackdropClick
      className={className}
    >
      <DialogTitle id="alert-dialog-title" className={classes.titleContainer}>
        <div className={classes.title}>{title}</div>
      </DialogTitle>
      <DialogContent className={classes.contentContainer}>
        <DialogContentText id="alert-dialog-description">
          <Typography component="span" className={classes.message}>{message}</Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions className={classes.actionsContainer}>
        <Button
          buttonRef={buttonRef}
          onClick={closeHandler}
          className={classes.button}
          variant="outlined"
        >
          {buttonText}
        </Button>
      </DialogActions>
    </Dialog>
  )
};

export default SimpleConfirmationDialog;
